import { createContext, useContext, useState, useEffect } from "react";
import { getLocalData, setLocalData, removeLocalData } from "./localStorageHelper";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Load user from localStorage on first mount
  useEffect(() => {
    const storedUser = getLocalData("userData");
    if (storedUser?.token) {
      setUser(storedUser);
    }
  }, []);

  // Login → save user both in state & localStorage
  const login = (userData) => {
    setUser(userData);
    setLocalData("userData", userData);
  };

  // Logout → clear user from state & localStorage
  const logout = () => {
    setUser(null);
    removeLocalData("userData");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
